export function getStepActionVerb(stepStatus: PolicyApplicationStep['status'] | undefined): string {
  switch (stepStatus) {
    case 'completed':
      return 'Edit';
    case 'in_progress':
      return 'Resume';
    default:
      return 'Start';
  }
}